const normalizeUrl = (str: string): string =>
    str.replace(/[/]+/g, '/').replace(/\/\?/g, '?').replace(/\/#/g, '#').replace(/:\//g, '://');

export const pathNoQueryHash = (path: string): string => {
    const queryIndex = path.indexOf('?');
    const hashIndex = path.indexOf('#');

    let result = path;

    if (queryIndex > -1 || hashIndex > -1) {
        result = path.substring(0, queryIndex > -1 ? queryIndex : hashIndex);
    }

    return result;
};

/**
 * Simple URL join. Join all string parameters as a URL. Does a simple normalizes aswell.
 * @returns {string} the url
 */
export function join(...stringsToJoin: Array<string>): string {
    const args = [].slice.call(stringsToJoin, 0).filter((val) => val !== undefined && val !== '');

    return normalizeUrl(args.join('/'));
}

const noAccents = (str: string): string => {
    if (!str) {
        return '';
    }

    return str
        .toLowerCase()
        .replace(/[àáâãäåāąă]/g, 'a')
        .replace(/[çćčĉċ]/g, 'c')
        .replace(/[ďđð]/g, 'd')
        .replace(/[èéêëēęěĕė]/g, 'e')
        .replace(/[ƒſ]/g, 'f')
        .replace(/[ĝğġģ]/g, 'g')
        .replace(/[ĥħ]/g, 'h')
        .replace(/[ìíîïīĩĭįı]/g, 'i')
        .replace(/[ĳĵ]/g, 'j')
        .replace(/[ķĸ]/g, 'k')
        .replace(/[łľĺļŀ]/g, 'l')
        .replace(/[ñńňņŉŋ]/g, 'n')
        .replace(/[òóôõöøōőŏœ]/g, 'o')
        .replace(/[Þþ]/g, 'p')
        .replace(/[ŕřŗ]/g, 'r')
        .replace(/[śšşŝș]/g, 's')
        .replace(/[ťţŧț]/g, 't')
        .replace(/[ùúûüūůűŭũų]/g, 'u')
        .replace(/[ŵ]/g, 'w')
        .replace(/[ýÿŷ]/g, 'y')
        .replace(/[žżź]/g, 'z')
        .replace(/[ß]/g, 'ss')
        .replace(/[&]/g, 'och')
        .replace(/[–—]/g, '-')
        .replace(/[/]/g, '-');
};

const justCharacters = (str: string) =>
    noAccents(str)
        .replace(/[^\w\s-]/g, '') // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
        .replace(/^-+|-+$/g, ''); // remove leading, trailing -

export const updateQuery = (query: any, params: any): any => ({ ...query, ...params });

export const slugify = (str: string): string => justCharacters(noAccents(str).replace(/[\s:_\-,.]+/g, '-')); // swap any length of whitespace, underscore, hyphen characters with a single - or , or .

export const formatUrl = (path: string, query = {}): string => {
    if (!path) {
        return '';
    }

    // TODO: encodeURIComponent and check that incoming queryparams are not already encoded
    const qs = Object.keys(query)
        .filter((key) => query[key] !== undefined && query[key] !== null)
        .map((key) => `${key}=${query[key]}`)
        .join('&');
    const separator = path.includes('?') ? '&' : '?';

    return `${path}${qs ? separator : ''}${qs}`;
};
